<template>
  <div>
    <EventDataTable :prefill="event" :isNew="isNewEvent" @result="handleResult"/>

    <Modal :title="modalTitle" ref="resultModal" @hidden="goHome">
      <template v-slot:body>
        <p v-if="success">
          You successfully {{ isNewEvent ? 'added an event!' : 'updated your event.' }} You can now monitor the status of this event from the
          <router-link to="/home">home page</router-link>
        </p>
        <p v-else>
          There was an error {{ isNewEvent ? 'adding' : 'updating' }} your event. Please try again later, or email
          <a href="mailto:founders@muvve.com?cc=muvvedev@gmail&#46;com&subject=Error%20adding%20event">
           founders@muvve&#46;com</a> if you're still having trouble. We apologize for the inconvenience.
        </p>
      </template>
    </Modal>

  </div>
</template>

<script>
import EventDataTable from '../components/EventDataTable'
import Modal from '../components/Modal'
import { Event } from '../data-models/event'
import EventsMixin from '../mixins/events'
import { Store } from '../store'

export default {
  components: {
    EventDataTable: EventDataTable,
    Modal: Modal
  },
  mixins: [
    { created: EventsMixin.created }
  ],
  data () {
    return {
      event: {},
      success: true
    }
  },
  computed: {
    isNewEvent () {
      return Object.keys(this.event).length === 0
    },
    modalTitle () {
      return this.success
        ? 'Success!'
        : `Error ${this.isNewEvent ? 'adding' : 'updating'} your event`
    }
  },
  methods: {
    handleResult (result) {
      this.success = !result.error && !(result instanceof Error)
      if (this.success) {
        Store.addEvent(new Event(result))
      }
      this.showResultModal()
    },
    showResultModal () {
      this.$refs.resultModal.show()
    },
    goHome () {
      if (this.success) {
        this.$router.replace('/home')
      }
    }
  }
}
</script>
